export default {
  name: "Directions",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M29.62 14.59 17.41 2.38c-.78-.78-2.05-.78-2.83 0L2.38 14.59c-.78.74-.78 2.08 0 2.83l12.21 12.21c.78.78 2.05.78 2.83 0l12.21-12.21c.77-.75.77-2.09-.01-2.83zM16 28.21 3.79 16 16 3.79 28.21 16 16 28.21zm-5.07-14.25h8v-2.79c0-.44.54-.67.85-.35l3.79 3.79c.19.19.19.51 0 .71l-3.79 3.79c-.32.32-.85.09-.85-.35v-2.79h-7v3c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.56.45-1.01 1-1.01z",
  },
}
